import React from 'react';
import { WardDto, HSPatient } from 'server-openapi';
import { format } from 'date-fns';
import { DateUtils } from '../../../core/utils/dateUtils';
import { Layout } from '../../../kit/Layout';
import { Text } from '../../../kit/Text';
import styled, { useTheme } from 'styled-components';
import { Image } from '../../../kit/Image';
import { useApiUtils } from '../../../syncstream/utils/hooks/useApiUtils';
import { displayMedicare, formatIhi } from "../../../core/utils/patientInfoUtils";
import TickInsideGreenCircle from "../../../kit/Icons/TickInsideGreenCircle";

interface IProps {
  patient: HSPatient;
  facility: WardDto;
  light?: boolean;
  extraTitle?: string;
}

export function PatientCompactInfo(props: IProps) {
  const theme = useTheme();
  const patientUtils = useApiUtils().patients;
  return (
    <Layout horizontal gap={0.5}>
      {props.patient.imageUrl && (
        <PatientImage src={props.patient.imageUrl} facilityGroupId={props.facility.facilityGroupId!} />
      )}
      <Layout>
        <h2 style={{ color: props.light ? theme.backgrounds.default.fg : theme.backgrounds.default.bg }}>
          {patientUtils.getDisplayPatientName(props.patient)}
          {props.extraTitle ?? ""}
        </h2>
        <h4 style={{ color: props.light ? theme.backgrounds.default.fg : theme.backgrounds.default.bg }}>
          <Text weight={'200'}>
            Room {props.patient.roomNumber}, {props.facility.name} &bull; DOB:{' '}
            {props.patient.dateOfBirth && format(DateUtils.toOffsetlessDate(props.patient.dateOfBirth), 'dd MMM yyyy')}{' '}&bull; Gender: {props.patient.gender}{' '}
              {props.patient.informedConsent === true && (<>&bull; Informed Consent: <TickInsideGreenCircle xlinkTitle={`Informed Consent`} width={13}/>{' '}</>)}
              &bull; MPS ID: {props.patient.hsId}
              {props.patient.urn && (<>&bull; MRN: {props.patient.urn}{' '}</>)}
              {props.patient.ihi && (<>&bull; IHI: {formatIhi(props.patient.ihi)}{' '}</>)}
              {props.patient.medicard && (<>&bull; Medicare: {displayMedicare(props.patient.medicard) ?? 'Unknown'}{' '}</>)}
              {props.patient.cardNumber && (<span><br/>&bull; DVA: {props.patient.cardNumber.toUpperCase()}{' '}</span>)}
              {props.patient.cardNumber && props.patient.cardColour && (<>({props.patient.cardColour}){' '}</>)}
              {props.patient.concessionNumber && (<>&bull; Concession: {props.patient.concessionNumber}{' '}</>)}
              {props.patient.concessionNumber && props.patient.concessionType && (<>Type: {props.patient.concessionType}{' '}</>)}
              {props.patient.pharmacy && props.patient.pharmacy.name && (<>&bull;{' '} Pharmacy:{' '}{props.patient.pharmacy.name}</>)}
          </Text>
        </h4>
      </Layout>
    </Layout>
  );
}

const PatientImage = styled(Image)`
  border-radius: 50%;
  width: 90px;
  height: 90px;
`;
